import { clientFetch } from 'app/utils/client-fetch';
import config from 'app/config';
import * as types from './types';
import { Arcade } from './interfaces';

export const apiGetArcade = (arcadeId: string) => {
    return clientFetch({
        url: `${config.ARCADE_API_URL}/arcades/${arcadeId}`,
        type: types.GET_ARCADE
    });
};

export const apiPostArcade = (arcade: Arcade) => {
    return clientFetch({
        url: `${config.ARCADE_API_URL}/arcades`,
        method: 'POST',
        type: types.POST_ARCADE,
        body: arcade
    });
};

export const apiPutArcade = (arcade: Arcade, arcadeId: string) => {
    return clientFetch({
        url: `${config.ARCADE_API_URL}/arcades/${arcadeId}`,
        method: 'PUT',
        type: types.PUT_ARCADE,
        body: arcade
    });
};
